import ApplicationController from './application_controller.js'

export default class extends ApplicationController {
  static targets = [
    'input',
    'dropdown',
    'option',
    'nameField',
    'selectedMetricField'
  ]
  static outlets = ['kaia--date-range-picker-component']

  connect() {
    this.boundCloseDropdown = this.closeDropdown.bind(this)
    document.addEventListener('click', this.boundCloseDropdown)
  }

  disconnect() {
    document.removeEventListener('click', this.boundCloseDropdown)
  }

  kaiaDateRangePickerComponentOutletConnected(dateRangePicker) {
    this.dateRangePicker = dateRangePicker
    dateRangePicker.onStartDateClick = () => this.handleDateChange()
    dateRangePicker.onEndDateClick = () => this.handleDateChange()
  }

  handleDateChange() {
    if (!this.element.checkValidity()) {
      if (this.dateRangePicker && this.dateRangePicker.rangepicker) {
        this.dateRangePicker.rangepicker.datepickers.forEach((dp) => dp.hide())
      }
      this.element.reportValidity()
      return
    }

    this.element.requestSubmit()
  }

  closeDropdown(event) {
    // Check if dropdown exists and is visible before trying to close it
    if (
      this.hasDropdownTarget &&
      !this.dropdownTarget.classList.contains('hidden')
    ) {
      // Only close if click is outside the searchable-select controller element
      if (!this.element.contains(event.target)) {
        this.dropdownTarget.classList.add('hidden')
      }
    }
  }

  showDropdown(event) {
    event.stopPropagation()
    this.dropdownTarget.classList.remove('hidden')
  }

  filter(event) {
    const query = this.inputTarget.value.toLowerCase()
    this.optionTargets.forEach((option) => {
      const metricName = option.dataset.metricName
      const displayText = option.dataset.displayText.toLowerCase()

      const matches = metricName.includes(query) || displayText.includes(query)
      option.classList.toggle('hidden', !matches)
    })

    this.showDropdown(event)
  }

  selectOption(event) {
    event.stopPropagation()
    const option = event.currentTarget
    const metricValue = option.dataset.metricValue
    const displayText = option.dataset.displayText

    this.inputTarget.value = displayText.split(' - ')[0] // Just the metric name

    this.nameFieldTarget.value = metricValue
    if (this.hasSelectedMetricFieldTarget) {
      this.selectedMetricFieldTarget.value = metricValue
    }

    this.dropdownTarget.classList.add('hidden')

    this.element.requestSubmit()
  }
}
